import React from "react";
import {
  FormControl,
  FormLabel,
  Switch,
  VStack,
  Badge,
} from "@chakra-ui/react";

function SwitchToggle({
  label,
  id,
  extra = "",
  variant,
  disabled = false,
  value,
  onClick,
}) {
  return (
    <FormControl className={`${extra}`} isDisabled={disabled} w="100%">
      <VStack spacing={2} align="start" w="100%">
        <FormLabel
          htmlFor={id}
          fontSize="sm"
          fontWeight={variant === "auth" ? "medium" : "bold"}
          color="navy.700"
          _dark={{ color: "white" }}
          mb={0}
        >
          {label}
        </FormLabel>

        <Switch
          id={id}
          isChecked={!!value}
          onChange={onClick}
          size="lg"
          colorScheme="green"
          sx={{ transform: "scale(1.2)", marginLeft: 1 }}
        />

        <Badge
          fontSize="sm"
          fontWeight="semibold"
          px={3}
          py={1}
          borderRadius="md"
          colorScheme={value ? "red" : "green"}
        >
          {value ? "Bloqueado: Sí" : "Bloqueado: No"}
        </Badge>
      </VStack>
    </FormControl>
  );
}

export default SwitchToggle;
